import { AppState } from '../store';

export const periodSelector = (state: AppState) =>
  state.periodReducer['default'];
